import {useEffect} from 'react';
import {ScrollView, View} from 'react-native';
import {Button} from 'react-native-paper';
import {Text} from '../../Components';
import {PageContainer} from '../../Containers';
import {useTheme} from '../../Hooks';
import {getCopy} from '../../Utils/I18n';
import {trackEvent} from '../../Utils/Telemetry';
import {RootSupportScreenProps} from '../../Typings/NavigationTypes';
import getStyles from './ADAPT-MH.styles';

type Props = RootSupportScreenProps;

const Support: React.FC<Props> = ({navigation, route}) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const isUrgent = Boolean(route.params?.urgent);
  const language = route.params?.language || 'en';
  const sessionId = route.params?.sessionId;
  const copy = getCopy(language);

  useEffect(() => {
    trackEvent('support_viewed', {sessionId, language, payload: {urgent: isUrgent}});
  }, [isUrgent, language, sessionId]);

  return (
    <PageContainer withSafeArea withPadding>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.hero}>
          <Text
            fontSize={30}
            lineHeight={37}
            weight="black"
            accessibilityRole="header"
            style={styles.title}
          >
            {copy.support.title}
          </Text>
          <Text fontSize={16} lineHeight={24} style={styles.subtitle}>
            {copy.support.subtitle}
          </Text>
        </View>

        {isUrgent ? (
          <View style={[styles.card, styles.urgentCard]}>
            <Text weight="bold" fontSize={18} style={styles.strongBody}>
              {copy.support.urgentTitle}
            </Text>
            <Text style={styles.listItem}>{copy.support.urgentBody}</Text>
          </View>
        ) : null}

        {copy.support.options.map((option) => (
          <View key={option.title} style={[styles.card, option.urgent ? styles.urgentCard : null]}>
            <Text weight="bold" fontSize={17} style={styles.strongBody}>
              {option.title}
            </Text>
            <Text style={styles.listItem}>{option.description}</Text>
          </View>
        ))}

        <Button
          mode="contained"
          onPress={() => navigation.navigate('Landing')}
          style={styles.button}
          buttonColor={theme.colors.primary}
          textColor={theme.colors.textContrast}
        >
          {copy.support.backToStart}
        </Button>
      </ScrollView>
    </PageContainer>
  );
};

export default Support;
